import { Dialog, DialogContent } from "@tellescope/ui";
import type { CalendarEvent } from "@tellescope/types-models";
import { AppointmentDetailsContent } from "./AppointmentDetailsContent";

interface AppointmentDetailsDialogProps {
  event: CalendarEvent | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  allowCancel: boolean;
  rescheduleUrl?: string;
}

export const AppointmentDetailsDialog = ({
  event,
  open,
  onOpenChange,
  allowCancel,
  rescheduleUrl,
}: AppointmentDetailsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        {event && (
          <AppointmentDetailsContent
            event={event}
            onOpenChange={onOpenChange}
            allowCancel={allowCancel}
            rescheduleUrl={rescheduleUrl}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
